<header class="w-full border-b border-base-200/70 bg-base-100 text-base-content">
  <div class="mx-auto flex h-14 max-w-[100rem] items-center justify-between gap-4 px-4 md:px-8">
    <!-- Brand: charity mark on charity hosts, Givebrite wordmark on platform.
         Colour lockups on the light bar. Charities without a colour mark fall
         back to their name as a text wordmark rather than to Givebrite
         branding. -->
    <div class="flex min-w-0 items-center gap-3">
      <a [routerLink]="AppRoutes.home()" class="flex items-center" [attr.aria-label]="brandName">
        @if (logoSrc) {
          <img
            [src]="logoSrc"
            [alt]="brandName + ' logo'"
            class="h-7 w-auto max-w-40 object-contain object-left select-none md:max-w-48"
          />
        } @else {
          <span class="text-base font-bold tracking-tight">{{ brandName }}</span>
        }
      </a>

      <!-- Etsy-style secure-checkout label: quiet reassurance beside the brand,
           checkout only. -->
      @if (isCheckout) {
        <span class="h-4 w-px shrink-0 bg-base-content/15" aria-hidden="true"></span>
        <span
          class="flex shrink-0 items-center gap-1.5 text-xs font-medium tracking-wide text-base-content/50"
        >
          <ui-icon name="lock" [size]="12" [strokeWidth]="2" />
          Secure checkout
        </span>
      }
    </div>

    <div class="flex items-center gap-2.5">
      <!-- Compact currency selector — minimal header only appears on checkout-family
           routes, where currency choice is always relevant. -->
      <gb-header-currency-select />

      @switch (isCheckout ? 'none' : ctx.route.headerAction) {
        @case ('signup') {
          <p class="m-0 text-sm text-base-content/60">
            <span class="hidden sm:inline">Don't have an account? </span>
            <a
              [routerLink]="AppRoutes.auth.register()"
              [queryParams]="{ signup: 'true' }"
              queryParamsHandling="merge"
              class="font-medium text-base-content underline underline-offset-4 hover:opacity-70"
            >
              Start a campaign
            </a>
          </p>
        }
        @case ('donate') {
          <a [routerLink]="AppRoutes.checkout.root()" class="btn btn-primary btn-sm rounded-full">
            Donate
          </a>
        }
      }
    </div>
  </div>
</header>
